"use client";

import React, { useState, useEffect } from "react";
import { MatchLabel } from "../Match";
import NoData from "@/components/client/NoData";
import ICON_ARROW_UP_LEAGUES from "@/public/arrow_up_white_leagues.svg";
import ICON_ARROW_DOWN_LEAGUES from "@/public/arrow_down_white_leagues.svg";
import MatchServices from "@/services/MatchServices";
import RecentLeaderBoardContainer from "../RecentLeaderBoardContainer";
import CollapsiblePanel from "@/components/client/CollapsiblePanel";

const IMAGE_ARROW_DOWN_LEAGUES = ICON_ARROW_DOWN_LEAGUES;
const IMAGE_ARROW_UP_LEAGUES = ICON_ARROW_UP_LEAGUES;

const renderNoData = () => {
  return (
    <CollapsiblePanel
      title="Thành tích gần đây"
      initOpen={true}
      iconUp={IMAGE_ARROW_UP_LEAGUES}
      iconDown={IMAGE_ARROW_DOWN_LEAGUES}
    >
      <NoData />
    </CollapsiblePanel>
  );
};

const RecentLeaderBoard = ({ matchId }) => {
  const [matchAnalysis, setMatchAnalysis] = useState(null);
  const [matchFormStats, setMatchFormStats] = useState(null);
  const [matchGoalStats, setMatchGoalStats] = useState(null);
  const [matchOddStats, setMatchOddStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMatchAnalysis = async () => {
      try {
        const [matchAnalysis, matchGoalStats, matchOddStats] = await Promise.all([
          MatchServices.getMatchAnalysis(matchId),
          MatchServices.getMatchGoalStats(matchId),
          MatchServices.getMatchOddStats(matchId),
        ]);
        setMatchAnalysis(matchAnalysis);
        setMatchGoalStats(matchGoalStats);
        setMatchOddStats(matchOddStats);

      } catch (error) {
        console.error("Error fetching match analysis:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMatchAnalysis();
  }, [matchId]);

  useEffect(() => {
    const fetchMatchFormStats = async () => {
      try {
        if (!matchAnalysis) {
          return;
        }

        const matchFormStats = await MatchServices.getMatchFormStats(
          matchId,
          `${matchAnalysis?.homeId},${matchAnalysis?.awayId}`
        );

        if (!matchFormStats || matchFormStats?.success == false) {
          setMatchFormStats(null);
          return;
        }

        setMatchFormStats(matchFormStats);
      } catch (error) {
        console.error("Error fetching match form stats:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMatchFormStats();
  }, [matchAnalysis]);

  if (loading) {
    return renderNoData();
  }

  if (!matchAnalysis || matchAnalysis.length === 0) {
    return renderNoData();
  }

  if (!matchFormStats || matchFormStats.length === 0) {
    return renderNoData();
  }

  const { homeId, awayId, leagueId } = matchAnalysis;

  const home = {
    id: homeId,
    name: matchAnalysis?.homeTeam?.name,
    logo: matchAnalysis?.homeTeam?.logo,
  };

  const away = {
    id: awayId,
    name: matchAnalysis?.awayTeam?.name,
    logo: matchAnalysis?.awayTeam?.logo,
  };

  return (
    <RecentLeaderBoardContainer
      leagueId={leagueId}
      home={home}
      away={away}
      formStats={matchFormStats}
      goalStats={matchGoalStats}
      oddStats={matchOddStats}
    />
  );
};

export default RecentLeaderBoard;
